<template>
  <div class="team-list-wrap">
    <h2 class="section-title">Teams</h2>

    <div v-if="loading" class="loading-spinner">
      <p>Loading teams...</p>
    </div>

    <div v-else-if="teams.length === 0" class="no-teams">
      <p>No teams available at the moment.</p>
    </div>

    <div v-else class="row">
      <div
        v-for="team in teams"
        :key="team.teamId"
        class="col-md-4 col-sm-6 mb-4"
      >
        <a
          :href="`${teamDetailBaseUrl}/${team.teamId}`"
          target="_blank"
          rel="noopener noreferrer"
          class="team-card-link"
        >
          <div class="team-card">
            <div class="team-image">
              <img
                :src="team.logo || defaultImage"
                :alt="team.teamName"
                @error="handleImageError"
              />
            </div>
            <div class="team-content">
              <h3>{{ team.teamName }}</h3>
              <p class="team-description">{{ team.teamDescription }}</p>
              <div class="team-meta">
                <span class="member-count">
                  <i class="fa fa-users"></i>
                  {{ getMemberCount(team) }} Members
                </span>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>

    <div v-if="pagination.lastPage > 1" class="pagination-wrap">
      <nav>
        <ul class="pagination">
          <li
            class="page-item"
            :class="{ disabled: pagination.currentPage === 1 }"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(pagination.currentPage - 1)"
            >
              Previous
            </a>
          </li>

          <li
            v-for="page in displayPages"
            :key="page"
            class="page-item"
            :class="{ active: page === pagination.currentPage }"
          >
            <a class="page-link" href="#" @click.prevent="changePage(page)">
              {{ page }}
            </a>
          </li>

          <li
            class="page-item"
            :class="{
              disabled: pagination.currentPage === pagination.lastPage,
            }"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(pagination.currentPage + 1)"
            >
              Next
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamList",
  data() {
    return {
      defaultImage: "/assets/images/no-image.png",
    };
  },

  props: {
    teams: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      required: true,
    },
    teamDetailBaseUrl: {
      type: String,
    },
    isMyTeams: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    displayPages() {
      const current = this.pagination.currentPage;
      const last = this.pagination.lastPage;
      const pages = [];

      // Show max 5 pages
      let start = Math.max(1, current - 2);
      let end = Math.min(last, current + 2);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
  },

  methods: {
    handleImageError(event) {
      // Prevent infinite loop if default image also fails
      if (event.target.src !== this.defaultImage) {
        event.target.src = this.defaultImage;
      }
    },
    getMemberCount(team) {
      // Use joinedMembersCount for "my teams", memberCount for public teams
      if (this.isMyTeams) {
        return team.joinedMembersCount || 0;
      }
      return team.memberCount || 0;
    },
    changePage(page) {
      if (page < 1 || page > this.pagination.lastPage) return;
      this.$emit("page-changed", page);
    },
  },
};
</script>

<style scoped>
.team-card-link {
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
}

.team-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer; /* ADD THIS */
}

.team-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.team-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s;
}

.team-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.team-image img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.team-content {
  padding: 20px;
}

.team-content h3 {
  margin-bottom: 10px;
  font-size: 1.5rem;
}

.team-description {
  color: #666;
  margin-bottom: 15px;
}

.team-meta {
  margin-bottom: 15px;
  color: #888;
}

.pagination-wrap {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
</style>
